export const rootPath = '/instruments/repair/locations';
export const entityPath = '/instruments/repair/locations/:id';

export const addTitle = 'Add Repair Location';
export const editTitle = 'Editing Repair Location';
export const listTitle = 'Repair Locations';
export const addButtonText = 'Add Location';
export const i18Namespace = 'RepairLocations';
